<div fxLayout="column" class="full-height">
  <div class="create-form-body full-width p-20" fxLayout="column" fxLayoutAlign="start center">
    <div class="pl-30 pr-30" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="20px">

      <div class="fx-row-w-100 fx-space-between fx-center fx-v-center" fxFlexOffset="20px">
        <span class="title-default">Create a Retailer</span>
      </div>

      <mat-button-toggle-group [value]="selectedType()" (change)="onTypeChange($event.value)"
                               class="custom-labeled-button-toggle">
        <mat-label>Retailer Type</mat-label>
        <mat-button-toggle [value]="TenantType.TENANT">Standard Retailer</mat-button-toggle>
        <mat-button-toggle [value]="TenantType.OFFERING">Offering Retailer</mat-button-toggle>
      </mat-button-toggle-group>

      @if (selectedType() === TenantType.TENANT) {
        <div [formGroup]="userForm" fxLayout="column" fxLayoutGap="20px" class="full-width">

          <div fxLayout="column" fxLayoutGap="7px">
            <span class="body-3-default">Email</span>
            <mat-form-field appearance="outline" class="custom-text-field" style="width: 100%;">
              <input matInput type="email" formControlName="email"
                     [readonly]="emailLocked()"
                     placeholder="Input text">
              <lib-form-field-errors controlName="email" [errorMap]="ERROR_MAP"></lib-form-field-errors>
            </mat-form-field>

            @if (!emailLocked()) {
              <span class="btn-cursor fx-align-self-end"
                    [ngClass]="!loading() && isEmailValid() ? 'subheading-primary' : 'subheading-default'"
                    (click)="!loading() && isEmailValid() ? onCheckEmail() : onCheckEmailInvalidInput()">
                {{ loading() ? 'Working...' : 'Check email' }}
              </span>
            }
            @if (emailLocked() && !emailEditMode()) {
              <span class="btn-cursor fx-align-self-end"
                    [ngClass]="!loading() ? 'subheading-primary' : 'subheading-default'"
                    (click)="!loading() ? onChangeEmail() : onCantProcessRequestAtThisTime()">
                {{ loading() ? 'Working...' : 'Change email' }}
              </span>
            }
            @if (emailEditMode()) {
              <app-info-panel [type]="PanelType.WARN"
                              [fullWidth]="true"
                              [message]="['Changing your email will clear the form']">
              </app-info-panel>
            }
          </div>

          <div fxLayout="column" fxLayoutGap="7px">
            <span class="body-3-default">First Name</span>
            <mat-form-field class="custom-text-field" appearance="outline" style="width: 100%;">
              <input matInput type="text" placeholder="Input text" formControlName="firstName">
              <lib-form-field-errors controlName="firstName" [errorMap]="ERROR_MAP"></lib-form-field-errors>
            </mat-form-field>
          </div>

          <div fxLayout="column" fxLayoutGap="7px">
            <span class="body-3-default">Last Name</span>
            <mat-form-field class="custom-text-field" appearance="outline" style="width: 100%;">
              <input matInput type="text" placeholder="Input text" formControlName="lastName">
              <lib-form-field-errors controlName="lastName" [errorMap]="ERROR_MAP"></lib-form-field-errors>
            </mat-form-field>
          </div>

        </div>
      }

      <div [formGroup]="retailerForm" fxLayout="column" fxLayoutGap="20px" class="full-width">

        <div fxLayout="column" fxLayoutGap="7px">
          <span class="body-3-default">Company Name</span>
          <mat-form-field class="custom-text-field" appearance="outline" style="width: 100%;">
            <input matInput type="text" placeholder="Input text" formControlName="companyName">
            <lib-form-field-errors controlName="companyName" [errorMap]="ERROR_MAP"></lib-form-field-errors>
          </mat-form-field>
        </div>

        <div fxLayout="column" fxLayoutGap="7px">
          <span class="body-3-default">Website Url</span>
          <mat-form-field appearance="outline" class="custom-text-field" style="width: 100%;">
            <input matInput type="text" placeholder="www.example.com" formControlName="websiteUrl">
            <lib-form-field-errors controlName="websiteUrl" [errorMap]="ERROR_MAP"></lib-form-field-errors>
          </mat-form-field>
        </div>

        <div fxLayout="column" fxLayoutGap="7px">
          <span class="body-3-default">Social Media Url</span>
          <mat-form-field appearance="outline" class="custom-text-field" style="width: 100%;">
            <input matInput type="text" placeholder="www.example.com/profile" formControlName="socialMediaUrl">
            <lib-form-field-errors controlName="socialMediaUrl" [errorMap]="ERROR_MAP"></lib-form-field-errors>
          </mat-form-field>
        </div>

        <div fxLayout="column" fxLayoutGap="7px">
          <span class="body-3-default">Industry And Product Collection</span>
          <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%;">
            <app-industry-select
              [offeringUuid]="offeringUuid()"
              formControlName="industryTypes"
              placeholder="Industry And Product Collection"
              [required]="true">
            </app-industry-select>
            <lib-form-field-errors controlName="industryTypes" [errorMap]="ERROR_MAP"></lib-form-field-errors>
          </mat-form-field>
        </div>

      </div>

      <lib-form-reset-action class="btn-cursor fx-align-self-center"
                             (resetForm)="resetForm()" [loading]="loader.loading$">
      </lib-form-reset-action>
    </div>
  </div>

  <div class="create-form-footer full-width px-4 py-3" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="12px">
    <button mat-flat-button class="button-secondary" type="button"
            (click)="cancel()">
      <div class="button-text">Cancel</div>
    </button>
    <button class="button-primary" mat-flat-button type="button"
            (click)="submitForm()"
            [disabled]="!!(loader.loading$ | async) || !canSubmit">
      <mat-icon>check</mat-icon>
      <div class="button-text">Save</div>
    </button>
  </div>
</div>
